import { atom } from "jotai";
import { atomWithImmer } from "jotai-immer";

export type MigrationWizardStep =
  | "repository"
  | "runners"
  | "docker-caching"
  | "checkout-caching"
  | "pull-request";

export const migrationWizardOpenAtom = atomWithImmer<boolean>(false);
export const migrationWizardStepAtom = atom<MigrationWizardStep>("repository");
